// extracted by mini-css-extract-plugin
module.exports = {"list-border":"list-border","item-list":"item-list","list":"list"};